// extracted by mini-css-extract-plugin
module.exports =  {"dateSeparator":"hd1FTgoe2mYYP29L66K9","link":"ArL24MZQ_v7cCMfoJ7Vd"};